/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/20/20
 * Time: 2:58 PM
 */
/* eslint-disable*/
import toastr from 'toastr';
import swal from "sweetalert";
import * as constants from "../const/constants";
import Cookies from "js-cookie";
import * as classService from "../services/class";
import * as lessonService from "../services/lessons";
import {lang, language} from '../const/language';


export const tConvert = (time) => {
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    time.splice(3, 1);
    return time.join(''); // return adjusted time or original string
}

export const b64EncodeUnicode = (str) => {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(
            match,
            p1
        ) {
            return String.fromCharCode("0x" + p1);
        })
    );
};
export const b64DecodeUnicode = (str) => {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
        atob(str)
            .split("")
            .map(function (c) {
                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
    );
};

export const notifyMessage = (msg, type, duration) => {
    let msgType = "warning";

    if (type === 2) {
        msgType = "warning"
    } else if (type === 0) {
        msgType = "error"
    } else if (type === 1) {
        msgType = "success"
    }
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": true,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "2500",
        "hideDuration": "2500",
        "timeOut": duration === undefined ? "5500" : duration,
        "extendedTimeOut": "2500",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    toastr[msgType](msg === undefined || msg === null ? "Please enter correct details" : msg, type === 0 ? 'Error' : type === 1 ? 'Success' : 'Warning')
};
export const formatCurrency = (val) => {
    val = val === undefined ? 0 : val;
    return val.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const onFileError = (error) => {
    notifyMessage(error.message);
};
export const studentPurchaseWarning = (props, obj) => {
    if (props.userType === 1) {
        swal({
            title: constants.ALERT_TEXT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    submitHandler(props, obj);
                    break;
                default:
                    break;
            }
        });
        return;
    }

    swal({
        title: constants.GUEST_STUDENT_FOR_PURCHASE,
        icon: null,
        closeOnClickOutside: false,
        buttons: {
            cancel: language[lang].NotNowText,
            dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
        },
    }).then((value) => {
        switch (value) {
            case "action":
                props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                break;
            default:
                break;
        }
    });
};

export const viewPaperResources = (props, id) => {

    if (props.userType === 1) {
        props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`,
            state: id
        })
    } else {
        swal({
            title: constants.GUEST_STUDENT_FOR_PAPER,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NotNowText,
                dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                    break;
                default:
                    break;
            }
        });
    }
};


export const submitHandler = async (props, obj) => {
    props.spinnerHandler({isSpin: true, type: 15});
    let service = classService;
    let payment = 'class';
    if (obj.classId === undefined && obj.lessonId !== undefined) {
        service = lessonService;
        payment = 'lesson'
    }
    Cookies.set(constants.PAYMENT_TYPE, payment);
    if (obj.status === constants.CARD_TYPE) {
        await service.enrollUsingCard(obj)
            .then(response => {
                props.spinnerHandler(false);
                console.log(response);
                if (response.success) {
                    window.location = response.body.payUrl;
                } else {
                    notifyMessage(response.message, response.status);
                }
            })
    } else if (obj.status === constants.SLIP_TYPE) {
        await service.enrollUsingSlip(obj)
            .then(response => {
                props.spinnerHandler(false);

                if (response.success) {
                    props.setPaymentModal(false, null);
                    swal({
                        // title: response.message,
                        title: obj.lessonId !== undefined ? language[lang].PaymentDepositSuccessLesson : language[lang].PaymentDepositSuccess,
                        icon: null,
                        closeOnClickOutside: false,
                        buttons: {
                            dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                        },
                    }).then((value) => {
                        switch (value) {
                            case "action":
                                props.history.push(`${constants.BASE_ROUTE}${constants.HOME_TEACHER_ROUTE}`);
                                break;
                            default:
                                break;
                        }
                    });

                } else {
                    notifyMessage(response.message, response.status);
                }
            })
    }
};

export const joinClassHandler = async (props, clz) => {

    props.spinnerHandler({isSpin: true, type: 15});
    await classService.joinZoomClass(clz.id)
        .then(response => {
            if (response.success) {
                let obj;
                let body = response.body;
                if (body.zoomMeetingJoinType === 'UNAUTHORIZED') {
                    obj = {
                        zoomMeetingId: body.zoomMeetingId,
                        zoomMeetingPassword: body.zoomMeetingPassword,
                        zoomSignatureJwt: body.zoomSignatureJwt,
                        classId: clz.id,
                        zoomMeetingJoinType: body.zoomMeetingJoinType
                    };
                    props.spinnerHandler(false);
                    props.history.push({
                        pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                        state: obj
                    })
                } else {
                    classService.joinZoomClassAuthorized(clz.id).then(res => {
                        if (res.success) {
                            obj = {
                                link: res.body,
                                zoomMeetingJoinType: 'AUTHORIZED'
                            };
                            props.spinnerHandler(false);
                            props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_JOIN_CLASS_ROUTE}`,
                                state: obj
                            })
                        }else{
                            props.spinnerHandler(false);
                            console.log('error');
                            let msgType = 'warning';
                            toastr[msgType](res.message);
                        }
                    }).catch(err => {
                        props.spinnerHandler(false);
                        console.log(err)
                    });
                }

            } else {
                props.spinnerHandler(false);
                notifyMessage(response.message, response.status);
            }
        }).catch(err => {
                props.spinnerHandler(false);
                console.log(err)
            }
        )
};


export function readFile(file) {
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.addEventListener("load", () => resolve(reader.result), false);
        reader.readAsDataURL(file);
    });
}

export const getB64ToBlob = (b64Data, contentType = 'image/png') => {
    const byteCharacters = atob(b64Data.substr(`data:${contentType};base64,`.length));
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {type: contentType});
    window.open(URL.createObjectURL(blob), '_blank');
};
export const removeCookiesValues = async () => {
    await Cookies.remove(constants.ACCESS_TOKEN);
    await Cookies.remove(constants.REFRESH_TOKEN);
    await Cookies.remove(constants.VERIFY_CODE);
};


export const viewClassResources = (props, id) => {
    if (props.userType === 1) {
        props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_LESSON_ROUTE}`,
            state: id
        })
    } else {
        swal({
            title: constants.GUEST_STUDENT_FOR_CLASS_LESSON_PURCHASE,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NotNowText,
                dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                    break;
                default:
                    break;
            }
        });
    }
};

export const getSliderSetting = (array) => {
    return {
        dots: true,
        institute: '',
        infinite: array.length > 4,
        autoplay: true,
        autoplaySpeed: 20000,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: array.length > 3,
                    dots: true
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: array.length > 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: array.length > 1,
                }
            }
        ]
    }
};
